/**
 * TanStack Query Client Konfiguration
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Nicht automatisch neu laden bei Fenster-Fokus
      refetchOnWindowFocus: false,
      // Keine Retries bei Fehlern (verhindert 429-Kaskaden)
      retry: false,
      // Daten sind 5 Minuten "frisch"
      staleTime: 5 * 60 * 1000,
      // Daten im Cache für 30 Minuten
      gcTime: 30 * 60 * 1000,
    },
    mutations: {
      // Keine Retries bei Mutations
      retry: false,
    },
  },
});

export default queryClient;




